export const isNative = () =>
  typeof window !== 'undefined' &&
  !!window.Capacitor &&
  typeof window.Capacitor.isNativePlatform === 'function' &&
  window.Capacitor.isNativePlatform();

export const isIOS = () => isNative() && window.Capacitor.getPlatform() === 'ios';
export const isAndroid = () => isNative() && window.Capacitor.getPlatform() === 'android';
export const isWeb = () => !isNative();
export const isStandaloneOrNative = () => {
  if (isNative()) return true;
  return !!(window.matchMedia && window.matchMedia('(display-mode: standalone)').matches);
};
